import { ReactElement, useMemo } from 'react';
import classnames from 'classnames';

import { Badge } from '@hh.ru/magritte-ui-badge';
import { Card } from '@hh.ru/magritte-ui-card';
import { CellRightLabel } from '@hh.ru/magritte-ui-cell';
import { TreeSelectorItemBase } from '@hh.ru/magritte-ui-tree-selector/TreeSelectorItemBase';
import TreeCollection from '@hh.ru/magritte-ui-tree-selector/collection/treeCollection';
import { AdditionalDefault, TreeModel } from '@hh.ru/magritte-ui-tree-selector/collection/types';
import { RenderItem } from '@hh.ru/magritte-ui-tree-selector/types';

interface MobileParentItemProps<Additional extends AdditionalDefault> {
    collection: TreeCollection<Additional>;
    item: TreeModel<Additional>;
    selected: string[];
    onClick: () => void;
    renderItem?: RenderItem<Additional>;
    isSearch: boolean;
    parentId?: string;
}

export const MobileParentItem = <Additional extends AdditionalDefault>({
    collection,
    item,
    selected,
    onClick,
    isSearch,
    parentId,
    renderItem = TreeSelectorItemBase,
}: MobileParentItemProps<Additional>): ReactElement => {
    const childrenSelectedCount = useMemo(() => {
        let count = 0;
        collection.walkChildren(item.id, (model) => {
            if (selected.includes(model.id)) {
                count += 1;
            }
        });

        return count;
    }, [collection, selected, item.id]);

    const labelRight = (
        <CellRightLabel badge={childrenSelectedCount ? <Badge>{childrenSelectedCount.toString()}</Badge> : undefined} />
    );

    return (
        <Card
            padding={16}
            borderRadius={12}
            showBorder
            actionCard
            stretched
            onClick={onClick}
            data-qa={classnames('tree-selector-item', `tree-selector-item-${item.id}`, {
                [`tree-selector-child-${parentId}`]: parentId,
            })}
        >
            {renderItem({ item, labelRight, childrenSelectedCount, isSearch, isXS: true, isParent: true })}
        </Card>
    );
};
